// TanStack Query hooks for the console Payments page (/api/payments).
//
// Every mutation invalidates ["payments"] so the table, the totals and any open statement
// refresh together.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type { PaymentCreate, PaymentRead, PaymentStatement, PaymentsSummary } from "./types";

export function usePaymentsSummary() {
  return useQuery({
    queryKey: ["payments", "summary"],
    queryFn: () => apiFetch<PaymentsSummary>("/api/payments/summary"),
    staleTime: 15_000,
  });
}

export function usePaymentStatement(uid: string | null) {
  return useQuery({
    queryKey: ["payments", "statement", uid],
    queryFn: () =>
      apiFetch<PaymentStatement>(`/api/payments/users/${encodeURIComponent(uid!)}/statement`),
    enabled: uid != null,
  });
}

export function useRegisterPayment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: PaymentCreate) =>
      apiFetch<PaymentRead>("/api/payments", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["payments"] });
      qc.invalidateQueries({ queryKey: ["dashboard"] });
    },
  });
}
